/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ServiceObjectToTicketV1Dto } from '../models/ServiceObjectToTicketV1Dto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ServiceObjectsTicketsService {
  /**
   * @param uuid objectId
   * @param ticketUuid ticketUuid
   * @returns ServiceObjectToTicketV1Dto create entity
   * @throws ApiError
   */
  public static serviceObjectTicketControllerV1AssignTicketV1(
    uuid: string,
    ticketUuid: string,
  ): CancelablePromise<ServiceObjectToTicketV1Dto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/service-objects/{uuid}/ticket/{ticketUuid}',
      path: {
        uuid: uuid,
        ticketUuid: ticketUuid,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
        409: `Conflict - Version mismatch (optimistic locking). Entity was modified by another request.`,
      },
    });
  }
  /**
   * @param uuid objectId
   * @param ticketUuid ticketUuid
   * @returns ServiceObjectToTicketV1Dto the entity
   * @throws ApiError
   */
  public static serviceObjectTicketControllerV1UnassignTicketV1(
    uuid: string,
    ticketUuid: string,
  ): CancelablePromise<ServiceObjectToTicketV1Dto> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/service-objects/{uuid}/ticket/{ticketUuid}',
      path: {
        uuid: uuid,
        ticketUuid: ticketUuid,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
        409: `Conflict - Version mismatch (optimistic locking). Entity was modified by another request.`,
      },
    });
  }
}
